export const SLIDE_TYPES = [
  { value: 'text-image', label: 'Text + Image' },
  { value: 'fact', label: 'Fact' },
  { value: 'text', label: 'Text' },
  { value: 'image', label: 'Image' },
];

export type SlideTemplateData = {
  title: string;
  markdown: string;
  background_image_id: string | null;
  image_id: string | null;
  add_question: boolean;
  question: string;
};

/**
 * Convert API template data (string array) to structured object
 */
export function parseSlideTemplateData(
  templateName: string,
  templateData: string[],
) {
  switch (templateName) {
    case 'text-image':
      return {
        title: templateData[0] || '',
        markdown: templateData[1] || '',
        image_id: templateData[2] || null,
        add_question: templateData[3] === 'true',
        question: templateData[4] || '',
        background_image_id: null,
      };
    case 'fact':
      return {
        title: templateData[0] || '',
        markdown: templateData[1] || '',
        background_image_id: templateData[2] || null,
        add_question: false,
        question: '',
        image_id: null,
      };
    case 'text':
      return {
        title: templateData[0] || '',
        markdown: templateData[1] || '',
        add_question: templateData[2] === 'true',
        question: templateData[3] || '',
        background_image_id: null,
        image_id: null,
      };
    case 'image':
      return {
        title: templateData[0] || '',
        image_id: templateData[1] || null,
        add_question: false,
        question: '',
        markdown: '',
        background_image_id: null,
      };
    default:
      return {
        add_question: false,
        question: '',
        background_image_id: null,
        image_id: null,
        markdown: '',
        title: '',
      };
  }
}

/**
 * Convert structured object to API template data (string array)
 */
export function serializeSlideTemplateData(
  templateName: string,
  templateData: SlideTemplateData,
) {
  switch (templateName) {
    case 'text-image':
      return [
        templateData.title || '',
        templateData.markdown || '',
        templateData.image_id || '',
        templateData.add_question ? 'true' : 'false',
        templateData.question || '',
      ];
    case 'fact':
      return [
        templateData.title || '',
        templateData.markdown || '',
        templateData.background_image_id || '',
      ];
    case 'text':
      return [
        templateData.title || '',
        templateData.markdown || '',
        templateData.add_question ? 'true' : 'false',
        templateData.question || '',
      ];
    case 'image':
      return [templateData.title || '', templateData.image_id || ''];
    default:
      return [];
  }
}
